// Small formatters the Requests page and the pieces split out of it share:
// the per-currency earnings shape, money/currency helpers, absolute media
// URLs, and the two Fans labels. Split out of pages/RequestsPage.tsx.
import { currencySymbol, formatSingleAmount } from "./currency";
import { SERVER_URL } from "../config";
import { t, formatLocale } from "../i18n";

// `total` = played requests (gross, our fee comes off it); `referral` = Refer &
// Earn money added to the balance (GET /orders/earnings referralByCurrency) —
// it cashes out with the requests and carries no fee.
export type EarningsTotals = Record<string, { total?: number; count?: number; referral?: number }>;

export const num = (v: any) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};
export const normCur = (cur?: string) => {
  const c = String(cur || "")
    .trim()
    .toLowerCase();
  return c && c !== "null" && c !== "undefined" ? c : "usd";
};
// Phase C: shared util — symbol + placement for all 12 pay-in currencies.
export const curSym = (cur?: string) => currencySymbol(normCur(cur));
export const SUFFIX_CUR = new Set(["sek", "dkk", "nok", "pln", "czk", "huf", "ron", "chf"]);
export const isSuffixCur = (cur?: string) => SUFFIX_CUR.has(normCur(cur));
export const fmtMoney = (cur: string | undefined, n: any) =>
  formatSingleAmount(num(n), normCur(cur));

// Универсальный нормализатор абсолютных ссылок
export const absUrl = (u?: string) =>
  !u ? "" : (u.startsWith("http") ? u : `${SERVER_URL}${u}`);

// "last Fri" / "Aug 24" / "Mar 3, 2025" — the last time this fan asked.
export const fanLastSeen = (iso: string): string => {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const days = (Date.now() - d.getTime()) / 86400000;
  if (days < 1) return t("requestsFormat.today");
  if (days < 7) return t("requestsFormat.lastWeekday", { weekday: d.toLocaleDateString(formatLocale(), { weekday: "short" }) });
  const sameYear = d.getFullYear() === new Date().getFullYear();
  return d.toLocaleDateString(formatLocale(), sameYear ? { month: "short", day: "numeric" } : { month: "short", day: "numeric", year: "numeric" });
};

// The chip must stay ONE line at every count (founder: "412 went
// beneath the line"): past 999 the number compacts to 1.2k / 12k, so the
// widest it ever gets is "Fans · 999". The card inside shows the full number.
export const formatChipCount = (n: number): string => {
  if (n < 1000) return String(n);
  if (n < 10000) return `${(n / 1000).toFixed(1).replace(/\.0$/, "")}k`;
  return `${Math.round(n / 1000)}k`;
};
